// extracted by mini-css-extract-plugin
export default {"addProducts":"Header_addProducts__8rRuT"};